// Detecção de mensagens de CSAT (pesquisa de satisfação feita via TEXTO, não o CSAT nativo)
// para ocultá-las na conversa e no preview da lista. Migrado do DASHBOARD_SCRIPTS runtime
// (MutationObserver, pesado) para o source — sem custo em runtime. (Abratel/Zaptel 2026-07-17)

const CSAT_SURVEY = /como foi (o )?seu atendimento|responda com um n[uú]mero|seu atendimento foi encerrado|avalie de.*1.*a.*5/i;
const CSAT_THANKYOU = /obrigado pela avalia[çc][aã]o|sua opini[aã]o nos ajuda/i;
const CSAT_RESPONSE = /^[1-5]\s*[⭐★☆⭐️⃣]{0,5}\s*$/;

const textOf = m => ((m && m.content) || '').trim();
const isOutgoing = m => (m ? (m.messageType ?? m.message_type) : null) === 1;
const isIncoming = m => (m ? (m.messageType ?? m.message_type) : null) === 0;

export const isCsatSurveyText = t => CSAT_SURVEY.test((t || '').trim());
export const isCsatThankYouText = t => CSAT_THANKYOU.test((t || '').trim());
export const isCsatResponseText = t => CSAT_RESPONSE.test((t || '').trim());

// Ids a ocultar na conversa: pesquisas + agradecimentos (saída) e a resposta
// numérica (entrada) que segue imediatamente uma pesquisa.
export const getCsatHiddenIds = (messages = []) => {
  const hidden = new Set();
  for (let i = 0; i < messages.length; i += 1) {
    const m = messages[i];
    if (isOutgoing(m) && isCsatSurveyText(textOf(m))) {
      hidden.add(m.id);
      for (let j = i + 1; j < messages.length; j += 1) {
        if (isIncoming(messages[j])) {
          if (isCsatResponseText(textOf(messages[j]))) hidden.add(messages[j].id);
          break;
        }
      }
    } else if (isOutgoing(m) && isCsatThankYouText(textOf(m))) {
      hidden.add(m.id);
    }
  }
  return hidden;
};

// Uma mensagem isolada é CSAT? (usado no preview da lista de conversas)
export const isCsatMessage = m => {
  if (!m) return false;
  const t = textOf(m);
  if (isOutgoing(m) && (isCsatSurveyText(t) || isCsatThankYouText(t))) return true;
  if (isIncoming(m) && isCsatResponseText(t)) return true;
  return false;
};
